import {computed, ref} from "vue";
import {useInfiniteQuery} from "@tanstack/vue-query";
import axios from "axios";
import _ from "lodash";

export const ApprovalCategoryEnum = Object.freeze({
  BLOG_STRATEGY: 'BLOG_STRATEGY',
  BLOG_POST: 'BLOG_POST',
  GBP_POST: 'GBP_POST',
  TONE_OF_VOICE: 'TONE_OF_VOICE',
  GBP_DESCRIPTION: 'GBP_DESCRIPTION',
  GBP_FAQ: 'GBP_FAQ',
  GBP_NEW_QUESTIONS: 'GBP_NEW_QUESTIONS',
  GBP_REVIEWS: 'GBP_REVIEWS',
  WEBSITE_COPY: 'WEBSITE_COPY',
  AUTOMATIC_APPROVAL_ACTION_FIX: 'AUTOMATIC_APPROVAL_ACTION_FIX',
});


const activeFilter = ref(null);
const filters = ref([]);
const totalCount = computed(() => _.sum(filters.value.map(key => key.count) ?? 0));

export const useApprovalCenterFilters = () => {
  const setActiveFilter = (filter) => {
    activeFilter.value = filter;
  };

  const showAll = () => {
    setActiveFilter(null);
  };

  return {
    activeFilter,
    setActiveFilter,
    showAll,
    filters,
    totalCount,
  };
};

export const useApprovals = (category, perPage = 3) => {
  const query = useInfiniteQuery({
    queryKey: ['approvals', category],
    queryFn: async ({pageParam}) => {
      const queryString = new URLSearchParams({
        category: category,
        page: pageParam,
        perPage: perPage,
      });

      const {data} = await axios.get(`/ajax/v2/approval-center?${queryString.toString()}`);

      return data;
    },
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta.current_page + 1 <= lastPage.meta.last_page ? lastPage.meta.current_page + 1 : null,
  });

  const approvals = computed(() => {
    if (!query.data.value?.pages) return [];
    return query.data.value.pages.flatMap((page) => page.data);
  });

  const handleLoadMore = async () => {
    if (query.hasNextPage.value && !query.isFetchingNextPage.value) {
      await query.fetchNextPage();
    }
  };

  return {
    ...query,
    approvals,
    handleLoadMore,
  };
};
